import { useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CalendarRange } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const parseISO = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
const toISO = (d) => format(d, "yyyy-MM-dd");
const label = (s) => format(parseISO(s), "dd MMM yyyy", { locale: es });

export function DateRangePicker({ from, to, onChange, testid = "date-range-picker" }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState();

  const onOpenChange = (v) => {
    if (v) setDraft(undefined);
    setOpen(v);
  };
  const apply = () => {
    if (!draft?.from) return;
    onChange({ date_from: toISO(draft.from), date_to: toISO(draft.to || draft.from) });
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-start font-normal" data-testid={`${testid}-trigger`}>
          <CalendarRange size={15} className="mr-2 text-muted-foreground" />
          <span className="truncate tabular-nums" data-testid={`${testid}-value`}>
            {from ? (from === to ? label(from) : `${label(from)} – ${label(to)}`) : "Seleccionar rango"}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testid}-popover`}>
        <Calendar mode="range" numberOfMonths={2} locale={es} defaultMonth={parseISO(from)} selected={draft} onSelect={setDraft} classNames={{ day_today: "font-bold underline underline-offset-4" }} />
        <div className="flex items-center justify-between gap-2 border-t border-border px-3 py-2">
          <span className="text-xs text-muted-foreground tabular-nums" data-testid={`${testid}-draft`}>
            {draft?.from ? `${toISO(draft.from)} → ${draft.to ? toISO(draft.to) : "…"}` : "Marca fecha inicial y final"}
          </span>
          <Button size="sm" onClick={apply} disabled={!draft?.from} data-testid={`${testid}-apply`}>Aplicar</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
